<template>
    <div class="reservation_item">
        <div class="reservation_item--date">
            <ul class="list-style-dot">
                <li> {{ eventTimeStart }} - {{ eventTimeEnd }} </li>
                <li> {{ eventDate }} </li>
            </ul>
        </div>
        <div class="reservation_item--title">
            {{ event.name }}
        </div>
        <div class="reservation_item--meta">
            <ul class="list-style-dot">
                <li> {{ eventType }} </li>
                <li> {{ placeName }} </li>
            </ul>
        </div>
        <div class="reservation_item--footer">
            <div v-if="eventTrainer" class="reservation_item--trainer">
                <div class="img" v-if="eventTrainerHasPhoto">
                    <img :src="eventTrainerPhotoUrl" :alt="eventTrainerName" onerror="this.parentElement.style.display='none'">
                </div>
                <div class="name">
                    {{ eventTrainerName }}
                </div>
            </div>

            <div class="reservation_item--icons">
                <ul>

                    <li v-if="event.payed === 'pay'">
                        <div class="reservation_item--icon">
                            <div class="text">
                                Платное
                            </div>
                            <div class="icon">
                                <img src="../assets/img/money.png">
                            </div>
                        </div>
                    </li>

                    <li v-if="event.type === 'kids'">
                        <div class="reservation_item--icon">
                            <div class="text">
                                Детское
                            </div>
                            <div class="icon">
                                <img src="../assets/img/kids.png">
                            </div>
                        </div>
                    </li>

                    <li v-if="event.transfer_event !== null && event.transfer_event !== undefined">
                        <div class="reservation_item--icon">
                            <div class="text">
                                Перенесено
                            </div>
                            <div class="icon">
                                <img src="../assets/img/transfer.png">
                            </div>
                        </div>
                    </li>

                </ul>
            </div>
        </div>

        <template v-if="event.cancel">
          <p class="reservation_item--status canceled">
            Занятие отменено
          </p>
        </template>

        <div v-else class="reservation_item--status" :class="status">
            {{ eventStatus }}
        </div>

    </div>
</template>

<script>
    import moment from 'moment'
    import { getReservationTrainer, getReservationTypeLabel, getTrainerDisplayName } from '../utilities'

    export default {
        name: "ReservationItem",
        props: {
            type: {},
            event: {},
            status: {}
        },
        computed: {
            eventType: function () {
                return getReservationTypeLabel(this.type)
            },
            placeName: function () {
                if (!this.event || !this.event.place) {
                    return ''
                }

                return typeof this.event.place === 'object' ? this.event.place.name : this.event.place
            },
            eventTrainer: function () {
                return getReservationTrainer(this.type, this.event?.trainer_replacement, this.event?.trainer)
            },
            eventTrainerName: function () {
                return getTrainerDisplayName(this.eventTrainer)
            },
            eventTrainerPhotoUrl: function (){
                return this.eventTrainer?.photo || ''
            },
            eventTrainerHasPhoto: function (){
                return !!this.eventTrainer?.photo
            },
            eventDate: function () {
                return moment(this.event.date, 'YYYY-MM-DD').format('dd, D MMMM ');
            },
            eventTimeStart: function () {
                return moment(this.event.time_start, 'HH:mm:ss').format('HH:mm');
            },
            eventTimeEnd: function () {
                return moment(this.event.time_end, 'HH:mm:ss').format('HH:mm');
            },
            eventStatus: function () {
                let status = '';

                switch (this.status) {
                    case 'unconfirmed':
                        status = 'Вы записаны'
                        break;
                    case 'confirmed':
                        status = 'Вы записаны'
                        break;
                    case 'refused':
                        status = 'Отказался'
                        break;
                    case 'closed':
                        status = 'Занятие завершено'
                        break;
                    case 'skipped':
                        status = 'Занятие пропущено'
                        break;
                    case 'late_cancel':
                        status = 'Поздняя отмена'
                        break;
                    case 'waiting':
                        status = this.event.status_label?.text || 'Лист ожидания';
                        break;
                    default:
                        status = 'Неизвестно'
                }

                return status
            }
        }
    }
</script>
